import type { GroupSelectOption } from '@rma/generic/ui/forms/group-select';

type WhenToSellType = GroupSelectOption & { icon?: string };

export const WhenToSellOptions = [
  { label: 'now', value: 'asap', icon: 'flash_on' },
  { label: 'threeMonths', value: 'threeMonths', icon: undefined },
  { label: 'sixMonths', value: 'sixMonths', icon: undefined },
  { label: 'twelveMonths', value: 'twelveMonths', icon: undefined },
  { label: 'later', value: 'later', icon: undefined },
] as const satisfies readonly WhenToSellType[];

export type WhenToSellOptionType = (typeof WhenToSellOptions)[number]['value'];
